import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-form',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-form.component.html',
  styleUrl: './skeleton-form.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonFormComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
